import React, { CSSProperties } from "react"

import { Body } from "~/components/ui"

import css from "./FilterCounter.module.scss"

interface PropTypes {
  count: number
  color?: CSSProperties["color"]
}

function FilterCounter({ count, color = "#BDBDBD" }: PropTypes) {
  return (
    <div
      className={css.root}
      style={{ "--background-color": color } as CSSProperties}
    >
      <Body variant="body3" semiBold color="white">
        {count}
      </Body>
    </div>
  )
}

export default FilterCounter
